<template>
	<section class="hot-rank_item"><slot></slot></section>
</template>
<script setup lang="ts"></script>

<style lang="scss" scoped>
.hot-rank_item {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	font-size: var(--font-s-large);
	font-weight: var(--font-w-bold);
	line-height: 2.5rem;
}
</style>
